module.exports = __webpack_public_path__ + "img/titlevi.392e1a15.png";